import React from 'react'
import Rollbar from 'rollbar'

import {
  ApiProvider,
  AppSettingsLoader,
  AuthenticationLoader,
  CurrencyBalanceLoader,
  CurrencyLoader,
  EthersLoader,
  GeotokensLoader,
  MinterAuctionsProvider,
  MinterProvider,
  NetworkSettingsLoader,
} from './Contexts'
import Portal from './Portal'

const getRollbarEnvironment = () => {
  switch (document.location.hostname) {
    case 'world.xyo.network':
      return 'production'
    case 'beta.world.xyo.network':
      return 'beta'
    default:
      return 'development'
  }
}

export const rollbar = new Rollbar({
  accessToken: '9ee8b08a0a8c4a2088991b629643029e',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: getRollbarEnvironment(),
})

export const App: React.FC = () => {
  return (
    <AppSettingsLoader>
      <NetworkSettingsLoader>
        <EthersLoader>
          <AuthenticationLoader>
            <ApiProvider>
              <GeotokensLoader>
                <CurrencyLoader>
                  <MinterProvider>
                    <MinterAuctionsProvider>
                      <CurrencyBalanceLoader>
                        <Portal />
                      </CurrencyBalanceLoader>
                    </MinterAuctionsProvider>
                  </MinterProvider>
                </CurrencyLoader>
              </GeotokensLoader>
            </ApiProvider>
          </AuthenticationLoader>
        </EthersLoader>
      </NetworkSettingsLoader>
    </AppSettingsLoader>
  )
}
